import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import {
  MyCafeteriaInfoLine,
  MyCafeteriaSignatureBlock,
  MyCafeteriaStatementTitle,
  MyCafeteriaVbkApplicationTable,
} from "my-cafeteria/components";
import { useMyCafeteriaCurrentStatement } from "my-cafeteria/hooks";
import { OcCurrency, OcSidebarPartnerLogo } from "oc/components";

interface MyCafeteriaVbkApplicationCardPrintProps {
  applicationDate: string;
  employeeName: string;
  idNumber: string;
  contractCode: string;
  currentYear?: number;
}

export const MyCafeteriaVbkApplicationCardPrint: React.FC<
  MyCafeteriaVbkApplicationCardPrintProps
> = ({
  applicationDate,
  employeeName,
  idNumber,
  contractCode,
  currentYear,
}) => {
    const { t } = useTranslation();
    const { data: statement } = useMyCafeteriaCurrentStatement({
      contractCode,
    });

    return (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        height="100%"
      >
        <Box id="upper-component" paddingBottom="48px">
          <MyCafeteriaStatementTitle
            label={t("MY_CAFETERIA_VBK_STATEMENT")}
            currentYear={currentYear ?? new Date().getFullYear()}
          />
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            paddingBottom="16px"
          >
            <Box id="data-block">
              <MyCafeteriaInfoLine
                label={t("OC_CALENDAR_DATE")}
                value={applicationDate}
              />
              <MyCafeteriaInfoLine
                label={t("OC_EMPLOYEE_NAME")}
                value={employeeName}
              />
              <MyCafeteriaInfoLine
                label={t("MY_CAFETERIA_TAX_ID_SIGN_ID")}
                value={idNumber}
              />
              <MyCafeteriaInfoLine
                label={t("MY_CAFETERIA_STATEMENT_CONTRACT_CODE")}
                value={contractCode}
              />
            </Box>
            <Box
              sx={{
                display: "none",
                displayPrint: "block",
                paddingRight: "85px",
              }}
            >
              <OcSidebarPartnerLogo />
            </Box>
          </Box>
          <Box display="flex" flexDirection="row" alignItems="center">
            <Box width="221px" textAlign="right">
              <Typography variant="h5">{t("MY_CAFETERIA_BUDGET")}</Typography>
            </Box>
            <Box width="16px" />
            <Box>
              <Typography
                variant="h5"
                style={{
                  fontWeight: 700,
                }}
              >
                {OcCurrency({ value: statement?.allAmount })}
              </Typography>
            </Box>
          </Box>
          <Box height="45px" />
          <Box padding="0px 17px">
            <MyCafeteriaVbkApplicationTable isMobile={false} />
          </Box>
        </Box>
        <MyCafeteriaSignatureBlock statement="vbk" />
      </Box>
    );
  };

export default MyCafeteriaVbkApplicationCardPrint;
